<template>
    <div class="content">
        <Header @cart-ref="setCartRef" />
        
        <div class="main-content">
            <div class="content-container">

                <div class="title-section">
                    <div class="back-content" @click="voltar" title="Voltar">
                        <i class="fa-solid fa-arrow-left"></i>
                    </div>
                    <h2 class="title-content"><i class="fa-solid fa-folder-open"></i> {{ disciplineName }}</h2>
                </div>
                <div class="grid-card" :class="{ 'layout-expandido': cardAtivo }">
                    <div class="card-wrapper" :class="{ expanded: cardAtivo === 'material-didatico' }">
                        <ExpandedCard v-if="cardAtivo === 'material-didatico'" tipo="material-didatico"
                            titulo="Material Didático" @fechar="cardAtivo = null" class="expanded"
                            :codigo="disciplineId" @add-to-cart="addToCart" />
                        <CategoryCard v-else titulo="Material Didático" tipo="material-didatico"
                            @abrir="abrirCategoria" @add-to-cart="addToCart" />
                    </div>

                    <div class="card-wrapper" :class="{ expanded: cardAtivo === 'video-aula' }">
                        <ExpandedCard v-if="cardAtivo === 'video-aula'" tipo="video-aula" titulo="Vídeo Aula"
                            @fechar="cardAtivo = null" class="expanded" :codigo="disciplineId" @add-to-cart="addToCart" />
                        <CategoryCard v-else titulo="Vídeo Aula" tipo="video-aula" @abrir="abrirCategoria" 
                            @add-to-cart="addToCart" />
                    </div>

                    <div class="card-wrapper" :class="{ expanded: cardAtivo === 'atividade' }">
                        <ExpandedCard v-if="cardAtivo === 'atividade'" tipo="atividade" titulo="Atividade"
                            @fechar="cardAtivo = null" class="expanded" :codigo="disciplineId" @add-to-cart="addToCart" />
                        <CategoryCard v-else titulo="Atividade" tipo="atividade" @abrir="abrirCategoria" 
                            @add-to-cart="addToCart" />
                    </div>

                </div>

            </div>

        </div>
        <a class="btn-adquirir-content" @click.stop="addPackageToCart" v-if="!cardAtivo">
            <span class="title-btn-adquirir"><i class="fa-solid fa-cart-shopping"></i> Adquirir o pacote inteiro</span>
        </a>
    </div>
</template>

<style scoped src="../styles/Content.css"/>

<script>
import CategoryCard from '../components/CategoryCard.vue';
import ExpandedCard from '../components/ExpandedCard.vue';
import Header from '../components/Header.vue';
import { getAdminPrices } from '@/utils/pricing';

export default {
    components: { CategoryCard, ExpandedCard, Header },
    data() {
        return {
            cardAtivo: null,
            disciplineName: null,
            disciplineId: null,
            cartComponent: null
        };
    },
    computed: {
        tituloCardAtivo() {
            const nomes = {
                'material-didatico': 'Material Didático',
                'video-aula': 'Vídeo Aula',
                'atividade': 'Atividade'
            };
            return nomes[this.cardAtivo];
        }
    },
    methods: {
        abrirCategoria(tipo) {
            this.cardAtivo = this.cardAtivo === tipo ? null : tipo;
        },
        voltar() {
            this.$router.back();
        },
        addToCart(item) {
            console.log("Adicionando ao carrinho:", item);
            if (this.cartComponent) {
                this.cartComponent.addToCart(item);
            } else {
                console.error("Componente do carrinho não está disponível");
            }
        },
        addPackageToCart(event) {
            event.stopPropagation();
            event.preventDefault();
            
            const packageItem = {
                codigo_disciplina: this.disciplineId,
                nome_disciplina: `${this.disciplineName} - Pacote Completo`,
                url_imagem: null,
                preco: getAdminPrices().combo_vip,
                tipo: 'pacote-completo',
                isPacote: true
            };
            
            console.log("Adicionando pacote completo ao carrinho:", packageItem);
            
            if (this.cartComponent) {
                this.cartComponent.addToCart(packageItem);
            } else {
                console.error("Componente do carrinho não está disponível");
            }
        },
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
            console.log("Referência do carrinho configurada:", cartRef);
        }
    },
    mounted() {
        console.log("Query params:", this.$route.query);
        this.disciplineName = this.$route.query.nome;
        
        if (this.$route.query.discipline) {
            this.disciplineId = this.$route.query.discipline;
        } else if (this.$route.query.codigo) {
            this.disciplineId = parseInt(this.$route.query.codigo);
        }
        
        console.log("ID da disciplina:", this.disciplineId);
        console.log("Nome da disciplina:", this.disciplineName);
        
        if (!this.disciplineId) {
            console.error("ERRO: Parâmetro 'discipline' ou 'codigo' não encontrado na URL!");
        }
    }
};
</script>
